import * as ActionsConstants from "../Constants/index";

const InitialState = {
	orders: [],
	lastClickedElement: {
		id: null,
	},
};

export const orders = (state = InitialState, action) => {
	switch (action.type) {
		case ActionsConstants.SET_ORDERS:
			return {
				...state,
				orders: action.data,
			};

		case ActionsConstants.SET_LAST_CLICKED_ELEMENT:
			return {
				...state,
				lastClickedElement:  action.data,
			};

		case ActionsConstants.CLEAR_STATE:
			return {
				...InitialState,
			};

		default:
			return {
				...state,
			};
	}
};

export default orders;
